// extracted by mini-css-extract-plugin
export default {"link":"ID-z","disabled":"JD-z"};